import { Observable, of, switchMap, tap } from 'rxjs';

export class LoadingAwareComponent {
    isLoading = false;

    protected withLoading<T>(obs: Observable<T>): Observable<T> {
        return of(null).pipe(
            tap(_ => this.isLoading = true),
            switchMap(_ => obs),
            tap(
                _ => this.isLoading = false,
                _ => this.isLoading = false
            )
        );
    }
}